import { render, staticRenderFns } from "./PublisherLink.vue?vue&type=template&id=3deec14b"
import script from "./PublisherLink.vue?vue&type=script&setup=true&lang=ts"
export * from "./PublisherLink.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports